module.exports = __webpack_public_path__ + "static/clouds-right-61fec4599e0a18726e11910b39f9d377.png";